export const usageIds = (tagsMap) => Object.keys(tagsMap).flatMap((dto) => tagsMap[dto].length > 0
    ? tagsMap[dto].map((usage) => `${dto}--${usage}`)
    : []);
export const usageId = (dto, tag) => tag && tag.length > 0
    ? `${dto}--${tag}`
    : dto;
